import { Column, Row } from '@/components'
import { themeBreakpointDown } from '@/utils'
import styled from 'styled-components'

export const TableContainer = styled(Column)<{ hasData?: boolean }>`
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid ${(props) => props.theme.color.b30};
  background-color: ${(props) => props.theme.color.b0};
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: ${({ hasData }) => (hasData ? '56px' : '0')};

  > div:first-child {
    width: 100%;
    padding: 16px 16px 0 16px;
  }

  > div:first-child span {
    white-space: normal;
  }
`

export const TableCell = styled.div<{
  margin?: string
  cursor?: string
  width?: string
}>`
  display: flex;
  margin: ${({ margin }) => margin || '0'};
  align-items: center;
  gap: 8px;
  cursor: ${({ cursor }) => cursor || 'inherit'};
  width: ${({ width }) => width || 'auto'};
`

export const InsuranceCellContainer = styled(Row)`
  padding: 0 8px 0 0;
  cursor: pointer;
  align-items: center;
  gap: 8px;
  width: 300px;

  ${themeBreakpointDown('sm')} {
    padding: 16px 8px 0 0;
    min-width: 200px;
    flex-wrap: no-wrap;
  }
`

export const InsuranceCellTextContainer = styled(Column)`
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 25ch;
  }

  svg {
    flex-shrink: 0;
    margin-left: 5px;
    > path {
      stroke: ${(props) => props.theme.color.b40};
    }
  }

  ${themeBreakpointDown('md')} {
    span {
      max-width: 25ch;
    }
  }
`

export const StyledRelativeContainer = styled.div`
  position: relative;
`
